import type { AppThemeConfig } from "@src/interfaces/theme-config.interface";

/**
 * Tides of Mind Counseling theme overrides layered on top of the Optum baseline.
 *
 * Keep this config as deltas only; any token or asset omitted here
 * inherits from the default Optum theme.
 */
export const TOFMDC_THEME_CONFIG: AppThemeConfig = {
  theme: {
    colors: {},
  },
  assets: {
    header: {
      title: {
        hidden: true,
      },
      logo: {
        src: "/themes/tofmdc/logo.png",
        alt: "Tides of Mind Counseling Logo",
        style: {
          width: "300px",
          height: "100%",
          padding: "10px 0",
          isMobile: { width: "200px" },
        },
      },
    },
    icons: {},
  },
  providerGroupId: [28, 30],
  state: "CT",
  departmentIds: [140, 147, 149, 154, 157, 164, 168, 172, 236],
};
